import type { Ref, RefCallback } from 'react'

/** Assigns one element to several refs, so a component can keep its own ref and forward the caller's. */
export const mergeRefs =
  <T>(...refs: (null | Ref<T> | undefined)[]): RefCallback<T> =>
  value => {
    for (const ref of refs) {
      if (typeof ref === 'function') ref(value)
      else if (ref) ref.current = value
    }
  }
